import {
	LoadingConfError,
} from '@exceptions/LoadingConfError';

export interface TypeConfig {
	[key: string]: string;
}

let configPromise: Promise<TypeConfig> | null = null;

// Export pour les tests uniquement
export const __resetConfigForTests = () => {
	configPromise = null;
};

export const loadConfig = async (hostname?: string, port?: string, pathname?: string): Promise<TypeConfig> => {
	if (configPromise) {
		return configPromise;
	}

	configPromise = (async () => {
		const currentDomain = hostname ?? window.location.hostname;
		const currentPort = port ?? window.location.port;
		const isLocalEnv = currentDomain.includes('localhost') || currentPort === '5173';
		const isMesOffresApp = (pathname ?? window.location.pathname).includes('/de/');
		const pathPrefix = isMesOffresApp ? 'de' : 'webapp';
		const pathToJsonConfig = isLocalEnv ? `/${pathPrefix}/.well-known/config.json?t=${new Date().getTime()}` : `/app/${pathPrefix}/.well-known/config.json?t=${new Date().getTime()}`;
		try {
			const response = await fetch(pathToJsonConfig);
			const config = await response.json();
			window.STONAL_CONFIG = config as TypeConfig;
			return config;
		} catch {
			configPromise = null;
			throw new LoadingConfError('Erreur lors du chargement de la configuration:', pathToJsonConfig);
		}
	})();

	return configPromise;
};

export const getConfig = async () => {
	const currentConfig = await loadConfig();
	return currentConfig;
};
